const initialState = {
    get: [], 
    
    
  
  };
  
  const DOActivityReudcers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_GET_SUCCESS':
            return {... state, get:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default DOActivityReudcers;
  
  